import { createApp } from 'vue';
import App from '@/App.vue';
import '@/assets/styles/app.scss';
import registerPlugins from '@/plugins';

registerPlugins(createApp(App)).mount('#app');
